

















import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {Decimal} from 'decimal.js'

import {CashoutData, Sku} from "../models";
import {formatCurrency} from "../util/number";
import {cashoutEventBus, CashoutEvents} from "../bus";

import SkuImage from "./SkuImage";

@Component({
    components: {
        SkuImage,
    }
})
export default class SkuListItem extends Vue {
    @Prop()
    cashoutData!: CashoutData;
    @Prop()
    sku!: Sku;

    get isSelected(): boolean {
        return this.cashoutData.selectedSkuId === this.sku.id;
    }

    get cashoutValue(): Decimal {
        return this.sku.cashoutValue(this.cashoutData.fiatAmount)
    }

    get cashoutValueFormatted(): string {
        return formatCurrency(this.cashoutValue, this.sku.currencyCode)
    }

    get bonusPercentage(): number {
        return this.sku.percentDiscount.toNearest(0.01).toNumber()
    }

    get availableForValue(): boolean {
        if (!this.cashoutData.minFiatAmount) return false;
        // Is th cashout value within range?
        return this.sku.inMinMaxRange(this.cashoutValue, this.cashoutData.minFiatAmount)
    }

    selectSku(event: MouseEvent) {
        if (!this.cashoutData.fxRate) return;
        if (this.cashoutData.orderInProgress) return;

        cashoutEventBus.$emit(CashoutEvents.SKU_SELECT, this.sku.id);
        // Remove outline after sku is clicked
        (event.target as HTMLAnchorElement).blur()
    }

}
